import { useTheme } from "@mui/material/styles";
import { DayPicker } from "react-day-picker";
import { id } from "react-day-picker/locale";

import "react-day-picker/style.css";

function Calendar({
    showOutsideDays = true,
    locale = id,
    ...props
}: React.ComponentProps<typeof DayPicker>) {
    const theme = useTheme();
    const primaryColor = theme.palette.primary.main;

    return (
        <DayPicker
            showOutsideDays={showOutsideDays}
            locale={locale}
            disabled={{ after: new Date() }}
            captionLayout="dropdown-years"
            styles={{
                root: {
                    "--rdp-accent-color": primaryColor,
                } as React.CSSProperties,
            }}
            {...props}
        />
    );
}

export { Calendar };
